export default "__VITE_ASSET__b90aa98b__"